const getters = {
    counts: state => state.user.items.reduce((a, b) => a.num + b.num),
    items: state => state.user.items,
    token: state => state.getToken.token
}
export default getters;